import { jsx as _jsx } from "react/jsx-runtime";
import { StepLabel as MuiStepLabel } from '@material-ui/core';
import { Box } from '../Box';
import { CheckIcon, ExclamationCircleIcon } from '../Icon';
import { TypeHelper } from '../Typography';
import { useTheme } from '../../themes';
import { withDefaultPropsAndStyles } from '../utils';
export { Step, Stepper, StepContent } from '@material-ui/core';
export const StepLabel = withDefaultPropsAndStyles('MuiStepLabel', MuiStepLabel, {
    defaultProps: {
        StepIconComponent: (props) => {
            const { palette } = useTheme();
            const { completed, icon, error, active } = props;
            const getColor = () => {
                if (error) {
                    return palette.error.main;
                }
                if (active || completed) {
                    return palette.primary.main;
                }
                return palette.text.secondary;
            };
            const Icon = (() => {
                const commonBoxProps = {
                    display: 'flex',
                    height: 24,
                    width: 24,
                    justifyContent: 'center',
                    alignItems: 'center',
                };
                if (error) {
                    return (_jsx(Box, Object.assign({}, commonBoxProps, { style: {
                            borderRadius: '50%',
                            fontSize: 24,
                        } }, { children: _jsx(ExclamationCircleIcon, { fontSize: "inherit", style: {
                                fill: palette.error.main,
                            } }, void 0) }), void 0));
                }
                if (completed) {
                    return (_jsx(Box, Object.assign({}, commonBoxProps, { style: {
                            background: getColor(),
                            borderRadius: '50%',
                        } }, { children: _jsx(CheckIcon, { fontSize: "inherit", style: {
                                fill: palette.text.inverse,
                            } }, void 0) }), void 0));
                }
                return (_jsx(Box, Object.assign({}, commonBoxProps, { style: {
                        border: 'solid 2px',
                        borderRadius: '50%',
                        borderColor: getColor(),
                        color: getColor(),
                    } }, { children: _jsx(TypeHelper, Object.assign({ customColor: "inherit", style: { fontWeight: 500 } }, { children: icon }), void 0) }), void 0));
            })();
            return Icon;
        },
    },
});
//# sourceMappingURL=Stepper.js.map